import { Controller } from "@hotwired/stimulus"

// Stepper du funnel /lancement (Clé en Main).
// Une question par écran ; le bouton Continuer ne s'active qu'après un choix ;
// les micro-accords (data-accord sur l'option) s'affichent sous les réponses.
export default class extends Controller {
  static targets = ["step", "progress", "progressFill", "progressLabel", "accord", "continue"]

  static STEP_NAMES = ["intro", "q1_activite", "q2_canal", "q3_paiement", "q4_volume",
                       "q5_pub", "q6_contenu", "q7_budget", "contact"]

  connect() {
    this.index = 0
    this.maxTracked = -1
    // Après une erreur de validation serveur (seuls les champs contact peuvent
    // échouer côté serveur), on renvoie directement à l'écran contact.
    if (this.element.querySelector(".lf-errors")) {
      this.index = this.stepTargets.length - 1
    }
    this.render()
  }

  pick(event) {
    const step = event.target.closest(".lf-step")
    const note = step.querySelector("[data-lead-funnel-target='accord']")
    const accord = event.target.dataset.accord

    if (note) {
      if (accord) {
        note.textContent = accord
        note.hidden = false
      } else {
        note.hidden = true
      }
    }
    const cont = step.querySelector("[data-lead-funnel-target='continue']")
    if (cont) cont.disabled = false
  }

  next() {
    if (this.index < this.stepTargets.length - 1) {
      this.index++
      this.render()
    }
  }

  back() {
    if (this.index > 0) {
      this.index--
      this.render()
    }
  }

  render() {
    this.stepTargets.forEach((step, i) => { step.hidden = i !== this.index })

    // Progression du funnel pour le tracking marketing (une fois par étape,
    // uniquement en avançant — le retour arrière ne compte pas deux fois).
    if (this.index > this.maxTracked) {
      this.maxTracked = this.index
      window.dispatchEvent(new CustomEvent("beb:track", {
        detail: {
          event_type: "funnel_step",
          meta: { step: this.index, step_name: this.constructor.STEP_NAMES[this.index] || `step_${this.index}` }
        }
      }))
    }

    // Barre de progression : visible sur les questions (1..7), pas sur
    // l'intro (0) ni sur l'écran contact (dernier).
    const questions = this.stepTargets.length - 2
    const onQuestion = this.index >= 1 && this.index <= questions
    if (this.hasProgressTarget) {
      this.progressTarget.hidden = !onQuestion && this.index !== this.stepTargets.length - 1
      const shown = Math.min(this.index, questions)
      this.progressLabelTarget.textContent =
        this.index === this.stepTargets.length - 1 ? "Dernière étape" : `Question ${shown} / ${questions}`
      this.progressFillTarget.style.width = `${(shown / questions) * 100}%`
    }
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
}
